import React from "react";

const Banner = ({ imagenFondo, imagenesCertificaciones }) => {
  return (
    
        <div className="flex w-full h-[300px] md:h-[400px] bg-azul-oscuro rounded-lg overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-300">
          {/* Sección Izquierda - Imagen de Fondo con Texto */}
          <div
            className="w-2/3 bg-cover bg-center flex items-center justify-center text-center px-6 relative group"
            style={{ backgroundImage: `url(${imagenFondo})` }}
          >
            {/* Overlay para mejorar la legibilidad del texto */}
            <div className="absolute inset-0 "></div>
            <h2 className="text-blanco text-2xl md:text-4xl font-bold drop-shadow-lg z-10 group-hover:scale-105 transition-transform duration-300">
              ESTÁNDARES, MEMBRESÍAS Y NORMATIVAS APLICABLES
            </h2>
          </div>
    
          {/* Sección Derecha - Certificaciones */}
          <div className="w-1/3 bg-gris-claro flex flex-col items-center justify-center p-6 space-y-6 ">
           
            <div className="flex flex-wrap justify-center gap-4">
              {imagenesCertificaciones.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Certificación ${index + 1}`}
                  className="w-20 md:w-24 object-contain transition-transform duration-300 hover:scale-110 hover:brightness-110"
                />
              ))}
            </div>
          </div>
        </div>
  );
};

export default Banner;
